import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import BcDialog, { CBcDialog, CBcDialogForm } from '@/components/Dialog.vue';
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
import BcMask from '@/components/Mask.vue';
class CHandlerForm extends CBcDialogForm {
    constructor(type, op) {
        super();
        const that = this;
        if (op && /object/i.test(typeof op)) {
            Object.keys(op).forEach((k) => {
                that[k] = op[k];
            });
        }
    }
}
let HospPerson = class HospPerson extends Vue {
    constructor() {
        super();
        this.dataSource = {
            headers: [
                { text: '医院', value: 'hospital', sortable: false },
                { text: '负责人', value: 'manager', sortable: false },
                { text: '第二负责人', value: 'secondManager', sortable: false },
                { text: '对接人员', value: 'transfer', sortable: false },
                { text: '技术人员', value: 'technicist', sortable: false },
                { text: '销售人员', value: 'salesman', sortable: false },
                {
                    text: '操作',
                    value: 'action',
                    sortable: false,
                    width: 120,
                    align: 'center',
                },
            ],
            desserts: [],
            isDetail: true,
        };
        this.pagination = {
            current: 10,
            countSum: 10,
            limit: 10,
            items: 10,
            curPre: 1,
        };
        this.maskValue = {
            isShow: false,
        };
        this.searchOptions = {
            quickly: '',
            timer: null,
        };
        // 医院人员信息
        this.dialogHandlers = new CBcDialog(new CHandlerForm());
        this.userInfoDic = {
            list: [],
            value: undefined,
            loading: true,
        };
        this.converArray = [
            'transfer',
            'technicist',
            'salesman',
            'manager',
            'secondManager',
        ];
        this.hospitalDic = {
            list: [],
            value: undefined,
            loading: true,
        };
        this.snackbar = new CBcSnackbar();
        const that = this;
        that.rules = {
            require: (value) => {
                if (!value || (!value && !value.replace(/\s+/g, ''))) {
                    return '该参数为必填项！';
                }
                return true;
            },
        };
    }
    mounted() {
        const that = this;
        that.getHisList();
        that.initUserList();
        that.initHospitalList();
    }
    async getHisList(value = false) {
        const that = this;
        that.maskValue.isShow = true;
        console.log('查询参数', that.searchOptions);
        const queryParams = {
            limit: typeof that.pagination.limit === 'number'
                ? that.pagination.limit
                : that.pagination.countSum,
            page: that.pagination.curPre,
            quickly: that.searchOptions.quickly || '',
            manager: that.searchOptions.manager || '',
            salesman: that.searchOptions.salesman || '',
        };
        that.dataSource.perPage = queryParams.limit;
        let rets;
        try {
            rets = await that.axios.get('/api/hospital/handlers', {
                params: queryParams,
            });
        }
        catch (e) {
            that.maskValue.isShow = false;
            return that.snackbar.error('获取信息失败！');
        }
        const dataValue = rets.data.result;
        that.dataSource.desserts = dataValue || [];
        that.pagination.items = Math.ceil(rets.data.sum / rets.data.limit) || 1;
        that.pagination.countSum = rets.data.sum;
        that.maskValue.isShow = false;
    }
    limitFun(value) {
        const that = this;
        that.pagination.limit = value;
        that.pagination.curPre = 1;
        that.getHisList();
    }
    pagePreFun(value) {
        const that = this;
        that.pagination.curPre = value;
        that.getHisList();
    }
    // 保存医院对接人信息
    async dialogHandlerSave() {
        const that = this;
        that.dialogHandlers.loading = true;
        that.dialogHandlers.positive.loading = true;
        try {
            if (that.dialogHandlers.isEditType
                || that.dialogHandlers.isCreateType) {
                that.converArray.forEach((o) => {
                    that.dialogHandlers.form[o] = that.dialogHandlers.form[`${o}Array`]
                        ? that.dialogHandlers.form[`${o}Array`].toString()
                        : '';
                });
            }
            if (that.dialogHandlers.isEditType) {
                // 修改
                await that.axios.put('/api/hospital/handlers/' + that.dialogHandlers.form.id, that.dialogHandlers.form);
            }
            else if (that.dialogHandlers.isCreateType) {
                // 新增
                await that.axios.post('/api/hospital/handlers', that.dialogHandlers.form);
            }
            else {
                await that.axios.delete(`/api/hospital/handlers/${that.dialogHandlers.form.id}`);
            }
            that.dialogHandlers.loading = false;
            that.dialogHandlers.positive.loading = false;
            that.dialogHandlers.visible = false;
            that.snackbar.success(`${that.dialogHandlers.title}成功！`);
            that.getHisList();
            if (that.dialogHandlers.isCreateType
                || that.dialogHandlers.isDeleteType)
                that.initHospitalList();
        }
        catch (e) {
            that.dialogHandlers.loading = false;
            that.dialogHandlers.positive.loading = false;
            console.log(e);
            that.snackbar.error(`${that.dialogHandlers.title}过程出错:`
                + (e && (e.info || e.result || e.error)));
        }
    }
    /**
     * 将数组对象转换成字符数组
     * @param array
     * @param key 默认为name
     */
    arrayToStringByKey(array, key = 'name') {
        return (array || []).map((v) => v[key]) || [];
    }
    async initUserList() {
        const that = this;
        that.userInfoDic.loading = true;
        const res = await that.axios.get('/api/users/');
        that.userInfoDic.list = [];
        if (res.data && res.data.result) {
            res.data.result.filter((o) => {
                if (o.usersInfo)
                    that.userInfoDic.list.push(o.usersInfo);
            });
        }
        that.userInfoDic.loading = false;
    }
    handlerDialog(type, data) {
        const that = this;
        if (type == 'edit') {
            that.converArray.forEach((o) => {
                data[`${o}Array`] = data[o] ? data[o].split(',') : [];
            });
        }
        that.dialogHandlers.type = type;
        that.dialogHandlers.width = /^xs$/i.test(that.$vuetify.breakpoint.name)
            ? '95%'
            : '60%';
        that.dialogHandlers.title = (type == 'add' ? '新增' : type == 'edit' ? '编辑' : '删除')
            + '医院人员信息';
        that.dialogHandlers.visible = true;
        that.dialogHandlers.displayText = false;
        that.dialogHandlers.autoClose = false;
        that.dialogHandlers.form = new CHandlerForm(type, data);
    }
    async initHospitalList() {
        const that = this;
        that.hospitalDic.loading = true;
        const res = await that.axios.get('/api/hospital/handlers/nothing');
        that.hospitalDic.list = (res.data && res.data.result) || [];
        that.hospitalDic.loading = false;
    }
    searchChange() {
        const that = this;
        clearTimeout(that.searchOptions.timer);
        that.searchOptions.timer = setTimeout(() => {
            that.getHisList();
        }, 1000); // 1秒执行一次获取函数 防抖
    }
};
HospPerson = __decorate([
    Component({
        name: 'Person',
        components: {
            BcSnackbar,
            BcDialog,
            BcMask,
        },
    })
], HospPerson);
export default HospPerson;
